import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Chip from "@mui/material/Chip";
import type { RunSnapshot } from "./useCompetitorLinkRemovalDetail";
import { CompetitorLinkRemovalLabels } from "./CompetitorLinkRemovalLabels";
import { Counter } from "./Counter";

interface RunProgressPanelProps {
  snapshot: RunSnapshot;
}

export function RunProgressPanel(props: RunProgressPanelProps) {
  const { snapshot } = props;
  const scannedSitesValue = `${snapshot.sitesScannedCount + snapshot.sitesFailedCount} / ${snapshot.totalSites}`;
  const processedPostsValue = `${snapshot.postsRemovedCount + snapshot.postsRemovalFailedCount} / ${snapshot.postsFoundCount}`;

  return (
    <Paper variant="outlined" sx={{ p: 2, mb: 3 }}>
      <Box display="flex" alignItems="center" gap={1} mb={2} flexWrap="wrap">
        <Typography variant="h6">Прогресс прогона</Typography>
        <Chip size="small" label={CompetitorLinkRemovalLabels.runStatus(snapshot.status)} />
        <Chip
          size="small"
          variant="outlined"
          label={`Автоудаление: ${CompetitorLinkRemovalLabels.autoRemove(snapshot.autoRemove)}`}
        />
      </Box>

      <Box
        display="grid"
        gridTemplateColumns="repeat(auto-fit, minmax(160px, 1fr))"
        gap={2}
      >
        <Counter
          label="Просканировано сайтов"
          value={scannedSitesValue}
        />
        <Counter label="Сайтов с ошибкой" value={String(snapshot.sitesFailedCount)} />
        <Counter label="Найдено постов" value={String(snapshot.postsFoundCount)} />
        <Counter label="Найдено ссылок" value={String(snapshot.linksFoundCount)} />
        <Counter
          label="Обработано постов"
          value={processedPostsValue}
        />
        <Counter label="Ошибок удаления постов" value={String(snapshot.postsRemovalFailedCount)} />
        <Counter label="Удалено ссылок" value={String(snapshot.linksRemovedCount)} />
      </Box>

      {snapshot.errorsByType.length > 0 && (
        <Box mt={2}>
          <Typography variant="subtitle2" mb={1}>Ошибки по типам</Typography>
          <Box display="flex" gap={1} flexWrap="wrap">
            {snapshot.errorsByType.map((entry) => (
              <Chip
                key={entry.type}
                size="small"
                color="error"
                variant="outlined"
                label={`${entry.type}: ${entry.count}`}
              />
            ))}
          </Box>
        </Box>
      )}
    </Paper>
  );
}
